<template>
    <div class="hoxton-alter-wall">
        <Loader :loading="showLoader" />
        <v-toolbar color="#222222" flat dense class="mb-4" style="cursor: pointer">
            <v-icon color="#337b52" class="ml-2" size="40" @click="goBack">mdi-arrow-left-bold-circle</v-icon>
            <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px !important">
                Alter Wall 40 – Team
            </v-toolbar-title>
        </v-toolbar>

        <v-container fluid>
            <v-row justify="center" class="team-grid">
                <v-col v-for="member in teamMembers" :key="member.name" cols="12" sm="6" md="4" lg="3"
                    class="team-member">
                    <div class="profile-card">
                        <div class="profile-image">
                            <img :src="member.image" :alt="member.name" />
                        </div>
                        <div class="profile-info">
                            <h3>{{ member.name }}</h3>
                            <p>{{ member.title }}</p>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>


<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Loader from "@/components/Loader.vue";

export default {
    name: "ArtInvestTeamView",
    components: {
        Loader,
    },
    setup() {
        const router = useRouter();
        const showLoader = ref(true);

        const teamMembers = ref([
            {
                name: " Aaron Berghaus",
                title: "Leiter Kostencontrolling",
                image: require("@/assets/Branding/Artinvest/ArtInvestTeamPictures/AB.jpg"),
            },
            {
                name: " Andrea Chrzan-Terjung",
                title: "Techn. Projektleitung",
                image: require("@/assets/Branding/Artinvest/ArtInvestTeamPictures/AT.jpg"),
            },
            {
                name: " Christoph Stephan",
                title: "Leiter MEP Nord",
                image: require("@/assets/Branding/Artinvest/ArtInvestTeamPictures/CS.jpg"),
            },
            {
                name: "Gerrit Persy",
                title: " Kfm. Projektleitung",
                image: require("@/assets/Branding/Artinvest/ArtInvestTeamPictures/GP.jpg"),
            },
            {
                name: "Juan Fernando Zauner",
                title: " Techn. Projektleitung",
                image: require("@/assets/Branding/Artinvest/ArtInvestTeamPictures/JZ.jpg"),
            },
            {
                name: "Sophia Duderstadt",
                title: " Techn. Projektleitung",
                image: require("@/assets/Branding/Artinvest/ArtInvestTeamPictures/SD.jpg"),
            },
            {
                name: " Wolfgang Hornischer",
                title: "Techn. Projektleitung",
                image: require("@/assets/Branding/Artinvest/ArtInvestTeamPictures/WH.jpg"),
            },
        ]);

        const goBack = () => {
            router.go(-1);
        };

        onMounted(() => {
            setTimeout(() => {
                showLoader.value = false;
            }, 1000);
        });

        return {
            showLoader,
            goBack,
            teamMembers,
        };
    },
};
</script>


<style scoped>
.team-grid {
    padding-top: 20px;
}

.profile-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    padding: 24px 16px;
    text-align: center;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
    transition: none;
    /* no animation */
}

.profile-image {
    width: 170px;
    /* Increased size */
    height: 185px;
    margin: 0 auto 16px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #337b52;
}

.profile-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile-info h3 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #222;
}

.profile-info p {
    font-size: 15px;
    color: #555;
    margin: 0;
}

@media (max-width: 600px) {
    .profile-card {
        padding: 16px 12px;
    }

    .profile-image {
        width: 140px;
        height: 140px;
    }

    .profile-info h3 {
        font-size: 18px;
    }

    .profile-info p {
        font-size: 14px;
    }
}
</style>
